import { render, staticRenderFns } from "./DateDisplay.vue?vue&type=template&id=39a160fb&scoped=true&"
import script from "./DateDisplay.vue?vue&type=script&lang=js&"
export * from "./DateDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DateDisplay.vue?vue&type=style&index=0&id=39a160fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a160fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDatePicker,VMenu,VSpacer})
